import React from 'react';
import { useTranslation } from 'react-i18next';
import PracticeAreas from '../sections/PracticeAreas';
import usePageMeta from '../hooks/usePageMeta';
import useLangPrefix from '../hooks/useLangPrefix';

function PracticeAreasPage() {
  const { t } = useTranslation();
  const langPrefix = useLangPrefix();

  usePageMeta({
    title: `${t('practiceAreas.heading')} | Marwa Hawshar`,
    description: t('practiceAreas.subheading'),
    path: `${langPrefix}/practice-areas`,
  });

  return (
    <>
      <h1 className="visually-hidden">{t('practiceAreas.heading')}</h1>
      <section className="py-5 py-lg-6 bg-white text-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <p className="text-muted mb-0">{t('practiceAreas.pageIntro')}</p>
            </div>
          </div>
        </div>
      </section>
      <PracticeAreas />
    </>
  );
}

export default PracticeAreasPage;
